// 새 스킬 습득 띠 대기열: 한 번의 EXP로 여러 해금 레벨을 넘으면 Ev.SkillLearned가 같은 묶음에 여러 건 온다.
// 뒤 건이 앞 띠를 바로 덮어쓰지 않도록 고정 크기 링에 쌓고, 앞 띠 연출이 끝났을 때 하나씩 꺼낸다. DOM·three를 모른다.
// 고정 버퍼라 푸시·꺼내기에서 할당이 없다(프레임 루프 불변식). 가득 차면 가장 오래된 건을 버린다(스킬은 5개뿐이라 실제로는 안 찬다).
export const SKILL_BAND_QUEUE_CAP = 8;

export class SkillBandQueue {
  private readonly buf = new Int32Array(SKILL_BAND_QUEUE_CAP);
  private head = 0;
  private n = 0;

  get count(): number { return this.n; }

  push(skill: number): void {
    if (this.n === SKILL_BAND_QUEUE_CAP) { this.head = (this.head + 1) % SKILL_BAND_QUEUE_CAP; this.n--; }
    this.buf[(this.head + this.n) % SKILL_BAND_QUEUE_CAP] = skill;
    this.n++;
  }

  /** 앞 띠가 재생 중(busy)이면 0(아무것도 안 꺼냄), 아니면 다음 스킬 번호(비었으면 0) */
  take(busy: boolean): number {
    if (busy || this.n === 0) return 0;
    const s = this.buf[this.head];
    this.head = (this.head + 1) % SKILL_BAND_QUEUE_CAP;
    this.n--;
    return s;
  }

  clear(): void { this.head = 0; this.n = 0; }
}
